<script>
import _ from 'lodash'
import DisplayVariableSchemaPopup from '@/components/execution/DisplayVariableSchemaPopup.vue'

export default {
  name: 'TulipVariableDisplay',
  components: {
    DisplayVariableSchemaPopup
  },
  props: {
    variableSchema: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      loader: false,
      search: '',
      headers: [
        {
          text: 'Variable Key',
          value: 'key'
        },
        {
          text: 'Type',
          value: 'type'
        },
        {
          text: 'Label',
          value: 'options.label'
        },
        {
          text: 'Value',
          value: 'options.value'
        }
      ]
    }
  },
  methods: {
    checkIfArray(input) {
      return _.isArray(input)
    },
    checkIfObject(input) {
      return _.isObject(input)
    }
  }
}
</script>

<template>
  <v-card :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
    <v-card-title>
      <span class="body-1 beez-bold pl-3">Variables</span>
      <v-spacer />
      <v-list-tile-avatar>
        <v-icon>search</v-icon>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-sub-title>
          <v-text-field v-model="search" color="secondary" label="Search" xs5>
          </v-text-field>
        </v-list-tile-sub-title>
      </v-list-tile-content>
      <v-tooltip bottom>
        <v-btn slot="activator" flat icon @click="search = ''">
          <v-icon>clear</v-icon>
        </v-btn>
        <span>Clear search</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-data-table
        :headers="headers"
        :items="variableSchema"
        :loading="loader"
        :search="search"
      >
        <template v-slot:items="props">
          <td class="text-xs-left">
            <div class="body-2 font-weight-bold orange--text">
              {{ props.item.key }}
            </div>
          </td>
          <td class="text-xs-left">{{ props.item.type }}</td>
          <td class="text-xs-left">{{ props.item.options.label }}</td>
          <td class="text-xs-left">
            <div
              v-if="
                checkIfArray(props.item.options.value) ||
                  checkIfObject(props.item.options.value)
              "
            >
              <DisplayVariableSchemaPopup :input="props.item" />
            </div>
            <div v-else>
              <div class="body-1 font-weight-bold">
                {{ props.item.options.value }}
              </div>
            </div>
          </td>
        </template>
        <template slot="no-data">
          <v-alert :value="true" color="info" icon="info">
            No variables found
          </v-alert>
        </template>
        <template slot="no-results">
          <v-alert :value="true" color="warning" icon="warning">
            Your search for "{{ search }}" not found.
          </v-alert>
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>
